
<template>
  <div class="detailsInfo">
    <el-dialog :title="titles" append-to-body :visible="dialogVisible" @close="closeDialog">
      <div style="padding:10px">
        <el-form :model="info" ref="ruleForm" label-width="170px" >
          <el-form-item label="商户名称:" >
            <span>{{info.storeName}}</span>
          </el-form-item>
          <el-form-item :label="info.type==1?'费用单号:':'调整单号:'">
            <span>{{info.relationSn}}</span>
          </el-form-item>
           <el-form-item v-if="info.type==1" label="费用类型:" >
            <span>{{info.typeName}}</span>
          </el-form-item>
          <el-form-item v-if="info.type==4" label="调整前可使用费用（元）:" >
            <span>{{info.withdrawCoin}}</span>
          </el-form-item>
          <el-form-item :label="info.type==1?'费用额度（元）:':'调整费用（元）:'">
            <span>{{info.changeCoin}}</span>
          </el-form-item>
          <el-form-item v-if="info.type==4"  label="调整后可使用费用（元）:" >
            <span>{{info.changeAfterCoin}}</span>
          </el-form-item>
          <el-form-item :label="info.type==1?'操作时间:':'调整时间:'" >
            <span>{{info.gmtModified | time}}</span>
          </el-form-item>
          <el-form-item :label="info.type==1?'备注:':'调整原因:'" >
            <span>{{info.remark}}</span>
          </el-form-item>         
        </el-form>
      </div>  
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确 定</el-button>
        <el-button @click="closeDialog">取 消</el-button>
      </div>
    </el-dialog>

    
  </div>
</template>

<script>
// import { queryBankTypeSet,updateBank, getBankLocationInfo } from "~/api/paymentSet";

export default {
  props:['showDialog','info',],
  data(){
    return {
      titles: null,
      dialogVisible: false,
    }
  },
  watch: {
    showDialog(value) {
      this.dialogVisible = value;
      if (value) {
      }
    },
    info: {
      handler: function (val) {
        if(val){
          this.setInit(val);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods:{
    setInit(info){
      if (info.type == 1) {
        this.titles = "费用充值明细";
      } else if(info.type == 4) {
        this.titles = "系统调整明细";
      }
    },  
    submit(){
      this.closeDialog()
    },

    closeDialog(){
      this.dialogVisible = false
      this.$emit('close')
    },
  }
}
</script>

<style lang="less">
  .detailsInfo{
    .el-select .el-input__inner {
      padding-right: 30px;
    }
  }
   
</style>